module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "files"
  }, [(_vm.title.length) ? _c('Title', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.files.length) ? _c('ol', {
    staticClass: "files__list"
  }, _vm._l((_vm.nameAndUrl), function(ref, index) {
    var name = ref.name;
    var url = ref.url;

    return _c('li', {
      key: index,
      staticClass: "files__item"
    }, [_c('a', {
      staticClass: "files__link",
      attrs: {
        "target": "_blank",
        "href": url
      }
    }, [_vm._v(_vm._s(name))])])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1042f38c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/itemsblock/components/files/Files.vue
// module id = 968b85e4cb485d8c106c
// module chunks = 89